import React, { useRef } from 'react';
import { DocumentSubCategory, DocumentUploadCategory, PropertyDocument, SUBCATEGORY_LABELS } from 'types/Documents';
import Button from 'components/Button/Button';
import InfoIcon from 'components/Icons/InfoIcon';
import FileTypeIcon from 'components/Icons/FileTypeIcon';
import { ModalRef } from 'components/Modal/Modal';
import UploadSvg from 'assets/icons/upload.svg?react';
import MapIcon from 'assets/icons/map.svg?react';
import { CategoryBadge, DoneBadge } from '../utils';
import { SUPPORTED_FILE_TYPES } from 'utils/documents';
import styles from '../NewOwnerOnboarding.module.css';

interface MapAndBluePrintItemProps {
    category: DocumentUploadCategory | undefined;
    mapAndBluePrintDocuments: PropertyDocument[];
    uploadDocuments: (e: React.ChangeEvent<HTMLInputElement>, category: DocumentUploadCategory) => Promise<void>;
    infoRef: React.RefObject<ModalRef>;
    disableInteractions: boolean;
}

function MapAndBluePrintItem({
    category: mapAndBluePrintCategory,
    mapAndBluePrintDocuments,
    uploadDocuments,
    infoRef,
    disableInteractions,
}: MapAndBluePrintItemProps): JSX.Element {
    if (!mapAndBluePrintCategory) return <></>;

    const propertyMapsInputRef = useRef<HTMLInputElement>(null);

    const uploadPropertyMapsFiles = async (e: React.ChangeEvent<HTMLInputElement>) => {
        await uploadDocuments(e, mapAndBluePrintCategory);
    };

    return (
        <div
            className={`${styles.item} ${
                mapAndBluePrintDocuments.length > 0
                    ? styles.done
                    : mapAndBluePrintCategory.is_required
                    ? styles.required
                    : ''
            }`}
        >
            <MapIcon className={styles.itemIcon} />
            <div>
                <div className={styles.titleRow}>
                    <span className={styles.itemTitle}>{SUBCATEGORY_LABELS[DocumentSubCategory.PROPERTY_MAP]}</span>
                    <CategoryBadge category={mapAndBluePrintCategory} />
                </div>
                <p className={styles.itemDescription}>Property layout or spot map to help with sign installation.</p>
            </div>
            <div className={styles.actions}>
                {mapAndBluePrintDocuments.length > 0 && <DoneBadge />}
                <button
                    className={styles.infoButton}
                    type="button"
                    aria-label="More info"
                    onClick={() => infoRef.current?.openModal()}
                >
                    <InfoIcon />
                </button>
                <input
                    ref={propertyMapsInputRef}
                    type="file"
                    hidden
                    multiple
                    accept={SUPPORTED_FILE_TYPES}
                    onChange={uploadPropertyMapsFiles}
                />
                <Button
                    color="info"
                    size="sm"
                    onClick={() => propertyMapsInputRef.current?.click()}
                    className={styles.actionButton}
                    disabled={disableInteractions}
                >
                    <UploadSvg />
                    Upload
                </Button>
            </div>
            {mapAndBluePrintDocuments.map((file, i) => (
                <div key={i} className={styles.fileItem}>
                    <FileTypeIcon fileType={file.file_type} size={20} />
                    <span className={styles.fileName}>{file.display_name}</span>
                </div>
            ))}
        </div>
    );
}

export default MapAndBluePrintItem;
